import api from '@/api'

const category = {
  state: {
    total: 0,
    categories: [],
    allCategories: []
  },

  mutations: {
    SET_CATEGORIES (state, { total = 0, categoryList = [] }) {
      state.total = total
      state.categories = categoryList
    },
    SET_ALL_CATEGORIES (state, { categoryList = [] }) {
      state.allCategories = categoryList
    }
  },

  actions: {
    createCategory ({ commit }, data) {
      return api.category.createCategory(data)
    },

    deleteCategory ({ commit }, data) {
      return api.category.deleteCategory(data)
    },

    updateCategory ({ commit }, data) {
      return api.category.updateCategory(data)
    },

    getCategories ({ commit }, data) {
      return api.category.getCategories(data).then(response => {
        commit('SET_CATEGORIES', response.data)
        return response
      })
    },

    getAllCategories ({ commit }, data) {
      return api.category.getCategories({
        ...data,
        query: {
          offset: 0,
          limit: 100
        }
      }).then(response => {
        commit('SET_ALL_CATEGORIES', response.data)
        return response
      })
    }

  }
}

export default category
